import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent) {
      setShow(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShow(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookieConsent", "declined");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#ffffff",
        borderTop: "1px solid rgba(0, 0, 0, 0.1)",
        boxShadow: "0 -4px 24px rgba(0, 0, 0, 0.08)",
        padding: "1.2rem 1.5rem",
        zIndex: 1000,
        backdropFilter: "blur(12px)",
      }}
    >
      <div className="container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem" }}>
        <div style={{ flex: "1", minWidth: "250px", color: "#374151", fontSize: "0.85rem" }}>
          <p style={{ margin: 0 }}>
            Ova web stranica koristi kolačiće (cookies) kako bismo vam pružili najbolje iskustvo. 
            Nastavkom korištenja stranice pristajete na korištenje kolačića.{" "}
            <Link 
              to="/privacy" 
              style={{ color: "#f97316", textDecoration: "underline" }}
            >
              Saznajte više
            </Link>
          </p>
        </div>
        <div style={{ display: "flex", gap: "0.8rem", flexWrap: "wrap" }}>
          <button
            onClick={declineCookies}
            className="btn ghost"
            style={{ fontSize: "0.75rem", padding: "0.5rem 1rem" }}
          >
            Odbij
          </button>
          <button
            onClick={acceptCookies}
            className="btn primary"
            style={{ fontSize: "0.75rem", padding: "0.5rem 1rem" }}
          >
            Prihvati
          </button>
        </div>
      </div>
    </div>
  );
}

